import { render, staticRenderFns } from "./NotesCreateView.vue?vue&type=template&id=045af6c9&scoped=true"
import script from "./NotesCreateView.vue?vue&type=script&lang=js"
export * from "./NotesCreateView.vue?vue&type=script&lang=js"
import style0 from "./NotesCreateView.vue?vue&type=style&index=0&id=045af6c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045af6c9",
  null
  
)

export default component.exports